<script lang="ts">
	import type { IExchangeData } from 'src/types/exchange';
	import NoIcon from 'assets/svg/noIcon.svg?url';
	import ImpactScore from 'components/ImpactScore/ImpactScore.svelte';
	import CustomButton from '../CustomButton/CustomButton.svelte';

	export let dark = false;
	export let data: IExchangeData;

	function checkForMissingImage(imageUrl: string) {
		return imageUrl === 'missing_small.png' ? NoIcon : imageUrl;
	}
</script>

<div class="wrapper" class:dark>
	<div class="logo-wrapper">
		<img
			class="exchange-logo"
			src={checkForMissingImage(data?.image)}
			alt={`${data?.customName ?? data?.name} logo`}
		/>
		<h1 class="exchange-name">
			{data?.customName ?? data?.name}
		</h1>
	</div>
	<div class="score-wrapper">
		<p class="score">
			<ImpactScore value={data?.trust_score} /><span class="text">trust score</span>
		</p>
		<CustomButton
			component="link"
			title="Start trading"
			linkTo={data?.ref || data?.url || `/exchanges/${data?.id}`}
			onClick={null}
			isExternalLink
		/>
	</div>
</div>

<style lang="scss">
	@import 'exchangeHeaderSection';
</style>
